import { Component, ChangeDetectorRef } from '@angular/core';


@Component({
  selector: 'ipm-wave-music',
  templateUrl: './wave-music.component.html',
  styleUrls: ['./wave-music.component.scss']
})
export class WaveMusicComponent  {
}
